<div class="value" *ngFor="let val of value">
  <p>{{val.caption || val.title || val.name}}</p>
  <p class="sub" *ngIf="val.subtitle">{{val.subtitle}}</p>
</div>
<div class="value" *ngIf="!value?.length">-</div>
